import { render } from "./ProjectShippingStep.vue?vue&type=template&id=5fcf2522"
import script from "./ProjectShippingStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectShippingStep.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/ProjectShippingStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fcf2522"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fcf2522', __exports__)) {
    api.reload('5fcf2522', __exports__)
  }
  
  module.hot.accept("./ProjectShippingStep.vue?vue&type=template&id=5fcf2522", () => {
    api.rerender('5fcf2522', render)
  })

}


export default __exports__